// extracted by mini-css-extract-plugin
export default {"footerFinal":"footer_footerFinal__McGRi","informationSideFooter":"footer_informationSideFooter__6sE3Y","rightReserved":"footer_rightReserved__JQ1MD"};